export default __webpack_public_path__ + "static/media/tete38.ece62868.png";